import { Component, Input, OnInit, ViewChild, AfterViewInit, ElementRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { OtpService } from 'src/app/services/otp.service';
import { RecaptchaService } from 'src/app/services/recaptcha.service';
import { GlobalServicesService } from '../services/global-services.service';
import { MessageService } from 'primeng/api';
@Component({
    selector: 'app-login-otp-verification',
    templateUrl: './login-otp-verification.component.html',
    styleUrls: ['./login-otp-verification.component.css'],
    standalone: false
})
export class LoginOtpVerificationComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() loginEmail: string = '';
  @Input() routingDetails: any;
  @Input() otpRequired: any;
  @Input() userDetails: any;
  @Input() privilegeData: any;
  @Input() onlyOTP: boolean = false;

  digit1: string = '';
  digit2: string = '';
  digit3: string = '';
  digit4: string = '';
  digit5: string = '';
  digit6: string = '';
  
  get otpValue(): string {
    return this.digit1 + this.digit2 + this.digit3 + this.digit4 + this.digit5 + this.digit6;
  }
  userName: string = '';
  infoMessage: any = {};

  btnLoading: boolean = false;
  pageLoading: boolean = false;
  sendOtpState: boolean = true;
  verifyOtpState: boolean = true;
  waitToResend: boolean = false;
  loadResend: boolean = false;
  clicked: boolean = false;
  invalidOTP: boolean = false;
  expiredOTP: boolean = false;
  displayInfoMessage: boolean = true;
  loginCheck: boolean = true;

  otpTimer: number = 0;
  countdown: string = '';
  redirectUrl: string = '';
 
  constructor(
    private otpService: OtpService,
    private router: Router,
    private globalService: GlobalServicesService,
    private messageService: MessageService,
    private recaptchaService: RecaptchaService,
  ) { }

  ngOnInit(): void {
    this.recaptchaService.initializeRecaptcha().catch(error => {
      console.warn('reCAPTCHA initialization failed:', error);
    });

    if(this.loginCheck){
      this.pageLoading = true;
      this.infoMessage = { 
        icon: 'pi pi-check', 
        message: 'OTP has been sent to ' + this.loginEmail, 
        bgColor: '#2d4185' 
      };
      this.startOtpTimer();
      this.btnLoading = false;
      this.sendOtpState = false;
      this.verifyOtpState = true;
      this.waitToResend = true;
      this.pageLoading = false;
    }
  }

  ngAfterViewInit(): void {
    this.initTiltEffect();
  }

  initTiltEffect(): void {
    const card = document.querySelector('.illustration-card') as HTMLElement;
    if (!card) return;

    card.addEventListener('mousemove', (e: MouseEvent) => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      const rotateX = (y - centerY) / 20;
      const rotateY = (centerX - x) / 20;
      card.style.transform = `rotate(-5deg) perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    });
    
    card.addEventListener('mouseleave', () => {
      card.style.transform = 'rotate(-5deg)';
      card.style.transition = 'transform 0.5s ease-out';
    });
  }
  onOtpChange(event: any, currentIndex: number) {
    const inputs = document.querySelectorAll('.otp-input') as NodeListOf<HTMLInputElement>;
    const input = event.target as HTMLInputElement;
  
    if (input.value.length === 0 && currentIndex > 0) {
      const prevInput = inputs[currentIndex - 1];
      if (prevInput) {
        prevInput.focus();
        prevInput.select();
      }
    } else if (input.value.length === 1 && currentIndex < inputs.length - 1) {
      const nextInput = inputs[currentIndex + 1];
      if (nextInput) {
        nextInput.focus();
      }
    }
    this.invalidOTP = false;
    this.expiredOTP = false;
  }
  isOtpComplete(): boolean {
    return this.otpValue.length === 6;
  }

  loginVerifyOtp = async () => {
    this.clicked = true;
    if (this.isOtpComplete()) {
      this.btnLoading = true;
      this.invalidOTP = false;
      this.expiredOTP = false;
      
      try {
        // Wait for reCAPTCHA to be loaded
        await this.recaptchaService.waitForRecaptcha();
        
        // Generate reCAPTCHA token
        const recaptchaToken = await this.recaptchaService.executeRecaptcha('verify_otp');
        
        let payload = { 
          email: this.loginEmail.toLowerCase(), 
          otp: this.otpValue,
          recaptcha_token: recaptchaToken
        };
        
        this.otpService.verifyOtpFastApi(payload).subscribe({
          next: (verifyRes) => {
            this.btnLoading = false;
            if (verifyRes.body.access_token) {
              this.invalidOTP = false;
              this.clicked = false;
              let accessToken = {
                access_token: verifyRes.body.access_token,
                token_type: verifyRes.body.token_type
              }
              localStorage.setItem('tokenFastApi', JSON.stringify(accessToken));
              this.globalService.getUserProfileFastApi().subscribe({
                next: (res: any) => {
                  localStorage.removeItem('CompanyDetails');
                  const privilege = res.body.auth_user_permissions || [];
                  const dashboardEnabled = res.body.company_metadata?.company_config?.dashboard ?? false;
                  const hasEventAccess = privilege.includes('event.view') || privilege.includes('event.create');
                  let redirectPath = '/settings';               
                  if (dashboardEnabled === true) {
                    redirectPath = '/dashboard';
                  } else if (hasEventAccess) {
                    redirectPath = '/events';
                  }
                  
                  this.router.navigateByUrl(redirectPath);
                },
                error: (error) => {
                  console.log(error); 
                }
              });
            }
          },
          error: (error: any) => {
            const errorMessage = error.error?.detail || 'OTP verification failed';
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: errorMessage,
            });
            this.btnLoading = false;
            this.clicked = false;
            this.displayInfoMessage = true;
          }
        });
      } catch (recaptchaError) {
        this.btnLoading = false;
        this.clicked = false;
        console.error('reCAPTCHA error:', recaptchaError);
        this.messageService.add({
          severity: 'error',
          summary: 'Authentication Error',
          detail: 'Unable to verify request. Please try again.'
        });
      }
    } else {
      this.invalidOTP = true;
    }
  }
  
  handlePaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') || '';
    if (pastedData.length === 6 && /^\d+$/.test(pastedData)) {
      const inputs = document.querySelectorAll('.otp-input') as NodeListOf<HTMLInputElement>;
      pastedData.split('').forEach((char, index) => {
        if (inputs[index]) {
          inputs[index].value = char;
        }
      });  
      this.digit1 = pastedData[0] || '';
      this.digit2 = pastedData[1] || '';
      this.digit3 = pastedData[2] || '';
      this.digit4 = pastedData[3] || '';
      this.digit5 = pastedData[4] || '';
      this.digit6 = pastedData[5] || '';  
      const lastInput = inputs[pastedData.length - 1];
      if (lastInput) {
        lastInput.focus();
      }
    }
  }
  
  resendOtp = (status: string) => {
    try {
      this.loadResend = true;
      let payload = {
        email: this.loginEmail.toLowerCase(),
      }
      this.otpService.sendOtpFastApi(payload).subscribe({
        next: (res: any) => {
          this.infoMessage = { 
            icon: 'pi pi-check', 
            message: 'OTP has been sent to ' + this.loginEmail, 
            bgColor: '#2d4185' 
          };
          this.displayInfoMessage = true;
          this.loadResend = false;
          this.waitToResend = true;
          if (status != 'tryAgain') {
            this.startOtpTimer();
          }
        },
        error: () => {
          this.loadResend = false;
        }
      });
    } catch (error) {
      console.log('resend error', error)
    }
  }

  startOtpTimer() {
    this.otpTimer = 60;
    this.countdown = this.formatTime(this.otpTimer);
    this.waitToResend = true;
    const intervalId = setInterval(() => {
      this.otpTimer--;
      this.countdown = this.formatTime(this.otpTimer);

      if (this.otpTimer === 0) {
        clearInterval(intervalId);
        this.waitToResend = false;
      }
    }, 1000);
  }

  formatTime(seconds: number): string {
    return `${seconds.toString().padStart(2, '0')}`;
  }

  restrictNumber(event: any) {
    let e: any = event || window.event;
    let key = e.keyCode || e.which;

    if (key == 13) {
      this.loginVerifyOtp();
    }    
    if (key < 48 || key > 57) {
      if (e.preventDefault) e.preventDefault();
      e.returnValue = false;
    }
  }

  otpKeyDown(event: any, currentIndex: number) {
    if ((event.keyCode === 8 || event.which === 8) && !event?.target?.value && currentIndex > 0) {
      event.preventDefault();
      const inputs = document.querySelectorAll('.otp-input') as NodeListOf<HTMLInputElement>;
      inputs[currentIndex - 1]?.focus();
      inputs[currentIndex - 1]?.select();
    }
  }

  ngOnDestroy(): void {
    this.recaptchaService.cleanupRecaptcha();
  }
}